import { Collapse } from "@material-ui/core";
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import { SnackbarProvider } from 'notistack';
import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import SnackbarCloseButton from "./components/commons/Snackbar/SnackbarCloseButton";
import { localEnvVariables } from "./constants/env";
import reportWebVitals from "./reportWebVitals";

Sentry.init({
	dsn: process.env.REACT_APP_SENTRY_DSN || localEnvVariables.REACT_APP_SENTRY_DSN,
	integrations: [new Integrations.BrowserTracing()],

	// Set tracesSampleRate to 1.0 to capture 100%
	// of transactions for performance monitoring.
	// We recommend adjusting this value in production
	tracesSampleRate: 1.0,
});

const notistackRef = React.createRef();

const onClickDismiss = key => () => {
	notistackRef.current.closeSnackbar(key);
}

ReactDOM.render(
	<React.StrictMode>
		<SnackbarProvider
			TransitionComponent={Collapse}
			ref={notistackRef}
			maxSnack={3}
			anchorOrigin={{
				vertical: 'bottom',
				horizontal: 'center',
			}}
			autoHideDuration={10000}
			preventDuplicate
			action={key => <SnackbarCloseButton onClick={onClickDismiss(key)} />}
		>
			<App />
		</SnackbarProvider>
	</React.StrictMode>,
	document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
// serviceWorker.register();